<ng-container *ngFor="let validation of ErrorMessagesArray">
	<p class="form-error-message"
		*ngIf="control && control.hasError(validation.Type) && (control.dirty || control.touched)">
		<!-- {{ validation.Message }} -->
		<ng-container i18n="{{':@@'+validation.Resource}}">{{validation.Message}}</ng-container>
	</p>
</ng-container>